// extracted by mini-css-extract-plugin
export default {"container":"modalMoreInfoForm_container__N+1Pf"};